module.exports = __webpack_public_path__ + "static/Anna-52eed036b09711c73bd1fee03595c0bb.png";